import { Accordion, styled, Theme, AccordionDetails } from '@material-ui/core';

export const TrajectoryItemAccordion = styled(Accordion)<Theme>(() => ({
  '&.MuiAccordion-root.Mui-expanded': {
    margin: 0,
  },
}));

export const TrajectoryItemAccordionDetails = styled(AccordionDetails)<Theme>(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
}));

export const AccordionItemWrapper = styled('div')<Theme, { color: string }>(({ theme, color }) => ({
  backgroundColor: theme.palette.white,
  borderLeft: '4px solid transparent',
  '&:hover': {
    borderLeft: `4px solid ${color}`,
  },
}));
